import { render, staticRenderFns } from "./MicrosoftQuotationCapture.vue?vue&type=template&id=2f02a603&"
import script from "./MicrosoftQuotationCapture.vue?vue&type=script&lang=js&"
export * from "./MicrosoftQuotationCapture.vue?vue&type=script&lang=js&"
import style0 from "./MicrosoftQuotationCapture.vue?vue&type=style&index=0&id=2f02a603&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports